import { configureStore } from '@reduxjs/toolkit';
import rootReducer from 'presentation/redux/modules/rootReducer';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['sessionParams']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)


const store = configureStore({ reducer: persistedReducer });
const persistor = persistStore(store);

export  { store, persistor };